// This function allow to reference chunks
__webpack_require__.k = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "." + "83b9b8df" + ".css"
}